import * as React from 'react';
import PropTypes from 'prop-types';
import {Link} from "gatsby";
import CategoryImage from './CategoryImage';
import {USD} from '../../helpers/NumberHelper';
import {uniformUrl} from "../../helpers/StringHelpers";
import {ProductTypeHelper} from "../../helpers/ProductTypeHelper";

const ProductGrid = ({ products, _page, _setPage, _query, _setQuery }) => {
  return (
    <div className={'grid grid-flow-row grid-cols-2 gap-8 md:grid-cols-3 xl:grid-cols-4'}>
      {products.map(hit => {
        const url = uniformUrl('/' + hit.url_key +'/');
        return (
          <div key={hit.sku} className={' flex flex-col items-center gap-2 py-10'}>
            <div className={' h-full transform duration-200 hover:scale-105'}>
              <CategoryImage
                sku={hit.sku}
                alt={hit.name}
                title={hit.title}
                normal={hit.small_image}
                thumb={hit.thumbnail}
                url={url}
                productType={hit.productType || ProductTypeHelper(hit)}
              />
            </div>
            {(hit.brand || '').length > 0 && (hit.model || '').length > 0 ? (
              <>
                <h2 className={'text-md h-full text-center font-bold'}>{hit.brand}</h2>
                <p>{hit.model}</p>
              </>
            ) : (
              <>
                <h2 className={'text-md h-full text-center font-bold'}>{hit.title}</h2>
              </>
            )}
            <div className={'text-md text-center'}>{USD(hit.price)}</div>
            <Link
              to={url}
              className={'mx-auto w-auto bg-accent p-4 py-2 text-white hover:bg-link'}
            >
              See Details
            </Link>
          </div>
        );
      })}
    </div>
  );
};

ProductGrid.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      categories: PropTypes.arrayOf(
        PropTypes.shape({ name: PropTypes.string.isRequired, id: PropTypes.number.isRequired })
      ).isRequired,
      url_key: PropTypes.string.isRequired,
      sku: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      small_image: PropTypes.shape({
        name: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }).isRequired,
      thumbnail: PropTypes.shape({
        name: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }).isRequired,
      brand: PropTypes.string,
      model: PropTypes.string,
      price: PropTypes.number,
    })
  ).isRequired,
};

export default ProductGrid;
